import { useState } from "react";
import Project from "./Project";

export default function Language({data}) {

    const [isShowMore, showMore] = useState(false);

    function toggleShowMore(e) {
        e.preventDefault();
        showMore(!isShowMore);
    }

    return (
        <div className="language">
            <div className="language-info">
                <img src={data.icon} alt={data.name}/>
                <h2>{data.name}</h2>
            </div>
            <div className="language-content">
                <span>{data.desc}</span>
                <br/>
                {(data.projects != null && isShowMore) && 
                        data.projects.map((project) => (
                            <Project data={project}/>
                        ))
                }
                {(data.projects != null) && (
                    <a href="none" onClick={toggleShowMore}>
                        {isShowMore ? "Show less" : "Read more"}
                    </a>
                )}
            </div>
        </div>
    )
}